import React from 'react';
import HeroSection from '../components/HeroSection';
import { Container, Row, Col, Card } from 'react-bootstrap';
import processImage from '../assets/images/process.jpg';
import '../css/home.css'; // Custom CSS

export default function Home() {
  return (
    <>
      <HeroSection />

      {/* Intro Section */}
      <div className="main-content intro-section">
        <Container>
          <Row className="mb-5 text-center" data-aos="fade-up">
            <Col>
              <h2>Welcome to Pursync</h2>
              <p className="intro-text">
                At Pursync, we harness cutting-edge AI technology to revolutionize dermatological care.
                Say goodbye to long queues and delayed appointments — our platform brings expert skin
                diagnostics directly to you.
              </p>
            </Col>
          </Row>

          {/* Feature Cards */}
          <Row>
            {[
              {
                title: "AI-Powered Diagnosis",
                text: "Instant skin condition analysis using advanced AI algorithms.",
                icon: "fas fa-microscope"
              },
              {
                title: "Expert Verification",
                text: "Every diagnosis is verified by board-certified dermatologists.",
                icon: "fas fa-user-md"
              },
              {
                title: "Accessible Anywhere",
                text: "Reach quality dermatological care even in remote locations.",
                icon: "fas fa-globe"
              }
            ].map((card, index) => (
              <Col md={4} key={index} data-aos="zoom-in" data-aos-delay={index * 100}>
                <div className="feature-card">
                  <div className="feature-icon animate-icon">
                    <i className={card.icon}></i>
                  </div>
                  <h4>{card.title}</h4>
                  <p>{card.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>

      {/* Problem - Solution Section */}
      <Container className="mt-5">
        <Row className="align-items-center mb-5">
          <Col md={6} data-aos="fade-right">
            <img src={processImage} alt="Process" className="img-fluid rounded shadow" />
          </Col>
          <Col md={6} data-aos="fade-left" className="d-flex align-items-center">
            <div className="d-flex flex-column gap-4 w-100">
              <Card className="problem-card shadow-sm border-0">
                <Card.Body>
                  <div className="icon-circle bg-danger text-white mb-3">
                    <i className="fas fa-exclamation-triangle fa-lg"></i>
                  </div>
                  <h4 className="fw-bold">The Problem</h4>
                  <p>
                    Millions lack access to reliable dermatological care, especially in remote and underserved areas.
                  </p>
                </Card.Body>
              </Card>

              <Card className="solution-card shadow-sm border-0">
                <Card.Body>
                  <div className="icon-circle bg-success text-white mb-3">
                    <i className="fas fa-lightbulb fa-lg"></i>
                  </div>
                  <h4 className="fw-bold">The Pursync Solution</h4>
                  <p>
                    Our platform uses AI to analyze skin images, offer instant diagnostics, and connect users with licensed dermatologists for further consultation.
                  </p>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>

        {/* Powered by AI */}
<Row className="align-items-center mb-5">
  {/* Image on left */}
  <Col md={6} data-aos="fade-right" className="text-center">
    <img
      src={require('../assets/images/ai-analysis.jpg')}
      alt="AI Skin Analysis"
      className="img-fluid rounded shadow"
    />
  </Col>
  {/* Text on right */}
  <Col md={6} data-aos="fade-left">
    <Card className="ai-card shadow-sm border-0">
      <Card.Body>
        <div className="icon-circle bg-primary text-white mb-3">
          <i className="fas fa-robot fa-lg"></i>
        </div>
        <h4 className="fw-bold">Powered by AI</h4>
        <p>
          Using computer vision and deep learning, our system evaluates various skin conditions
          and provides a confidence-based diagnosis — all within seconds.
        </p>
      </Card.Body>
    </Card>
  </Col>
</Row>

{/* Verified by Experts */}
<Row className="align-items-center mb-5">
  {/* Text on left */}
  <Col md={6} data-aos="fade-right">
    <Card className="expert-card shadow-sm border-0">
      <Card.Body>
        <div className="icon-circle bg-warning text-dark mb-3">
          <i className="fas fa-user-md fa-lg"></i>
        </div>
        <h4 className="fw-bold">Verified by Experts</h4>
        <p>
          Every AI diagnosis is cross-checked by our network of board-certified dermatologists
          to ensure 100% reliability and patient safety.
        </p>
      </Card.Body>
    </Card>
  </Col>
  {/* Image on right */}
  <Col md={6} data-aos="fade-left" className="text-center">
    <img
      src={require('../assets/images/doctor.jpg')}
      alt="Expert Dermatologist"
      className="img-fluid rounded shadow"
    />
  </Col>
</Row>



        {/* Contact Us Section */}
        <Row className="mt-5" data-aos="fade-up">
          <Col md={6}>
            <h3>Contact Us</h3>
            <p>Have questions or need support? We’re here to help.</p>
            <ul className="list-unstyled contact-info">
              <li><i className="fas fa-envelope"></i> support@pursync.com</li>
              <li><i className="fas fa-phone"></i> +91 98765 43210</li>
              <li><i className="fas fa-map-marker-alt"></i> Hyderabad, India</li>
            </ul>
          </Col>
          <Col md={6}>
            <form className="contact-form shadow-sm p-4 rounded">
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input type="text" className="form-control" placeholder="Your Name" />
              </div>
              <div className="mb-3">
                <label className="form-label">Email</label>
                <input type="email" className="form-control" placeholder="Your Email" />
              </div>
              <div className="mb-3">
                <label className="form-label">Message</label>
                <textarea className="form-control" rows="4" placeholder="Your Message"></textarea>
              </div>
              <button type="submit" className="btn btn-hero">Send Message</button>
            </form>
          </Col>
        </Row>
      </Container>
    </>
  );
}
